import { gql } from "@/services/httpAdapter.ts";

export const onUpdateTradeInPayOffs = gql`
	subscription onUpdateTradeInPayOffs($commissionCycleId: String!, $payPeriodId: String!) {
		onUpdateTradeInPayOffs(commissionCycleId: $commissionCycleId, payPeriodId: $payPeriodId) {
			locationId
			commissionCycleId
			payPeriodId
			tradeInPayOffs {
				_id
				actualCashValue
				commissionCycleId
				createdAt
				dealNumber
				dealStatus
				dealStockId
				dealVin
				financeEmployeeId
				financeEmployeeName
				lender {
					address {
						city
						addr1
						state
						zip
					}
					lenderName
					lenderType
				}
				locationId
				overallowanceAmt
				payPeriodId
				payoff
				stockID
				tradeInAmt
				tradeInVin
				creationDateTime
				updatedAt
				vehicle {
					accentClr
					carline
					extClrDesc
					makePfx
					modelDesc
					vehicleDetail {
						weight
						licExpDate
						licNo
						newUsed
						noOfCyl
						odomReading
						unitsOfMeasure
					}
					vehicleMake
					vehicleYr
					vin
				}
			}
		}
	}
`;
